import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { DetailsSection } from '../components/DetailsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ClosingSection } from '../components/ClosingSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  useEffect(() => {
    // Add Google Fonts
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&family=Source+Sans+3:ital,wght@0,400;0,600;0,700;1,400&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  return <div className="min-h-screen bg-[#FAFAF7] text-[#1A1A1A] font-sans selection:bg-[#D4C5A9] selection:text-[#2B4257]" data-id="element-357">
      <style data-id="element-358">{`
        :root {
          --font-heading: 'Playfair Display', serif;
          --font-body: 'Source Sans 3', sans-serif;
          --color-navy: #2B4257;
          --color-teal: #6B9B8A;
          --color-sand: #D4C5A9;
          --color-bg: #FAFAF7;
        }
        
        body {
          font-family: var(--font-body);
        }
        
        h1, h2, h3, h4, h5, h6 {
          font-family: var(--font-heading);
        }

        .fade-in-up {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
          transform: translateY(20px);
        }

        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .delay-100 { animation-delay: 100ms; }
        .delay-200 { animation-delay: 200ms; }
        .delay-300 { animation-delay: 300ms; }
      `}</style>

      <main className="w-full" data-id="element-359">
        <HeroSection data-id="element-360" />
        <ProblemSection data-id="element-361" />
        <SolutionSection data-id="element-362" />
        <DetailsSection data-id="element-363" />
        <TestimonialsSection data-id="element-364" />
        <ClosingSection data-id="element-365" />
        <FAQSection data-id="element-366" />
        <Footer data-id="element-367" />
      </main>
    </div>;
}